import { cn } from '@/lib/utils';

/**
 * marKIpilot Logo Component
 * Das "KI" wird hervorgehoben um die AI/KI-Positionierung zu betonen
 */
export const Logo = ({ size = 'default', showText = true, className }) => {
  const sizes = {
    small: { icon: 'w-6 h-6', text: 'text-sm', ki: 'text-sm' },
    default: { icon: 'w-8 h-8', text: 'text-base', ki: 'text-base' },
    large: { icon: 'w-12 h-12', text: 'text-2xl', ki: 'text-2xl' },
    hero: { icon: 'w-14 h-14', text: 'text-3xl', ki: 'text-3xl' }
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {/* Logo Icon - Stilisiertes "M" mit Flugzeug/Pilot-Element */}
      <div className={cn(s.icon, 'relative rounded-xl bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center shadow-lg')}>
        {/* Stilisiertes "M" für marKI */}
        <svg viewBox="0 0 32 32" className="w-[60%] h-[60%]" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Flugzeug/Pilot stilisiert */}
          <path 
            d="M16 4L22 12L28 10L24 16L28 22L22 20L16 28L10 20L4 22L8 16L4 10L10 12L16 4Z" 
            fill="#2BAE9B" 
            className="drop-shadow-sm"
          />
          {/* Innerer Akzent */}
          <circle cx="16" cy="16" r="4" fill="white" fillOpacity="0.9" />
        </svg>
      </div>

      {/* Text Logo */}
      {showText && (
        <span className={cn('font-display font-bold tracking-tight', s.text)}>
          <span className="text-slate-900">mar</span>
          <span className="text-teal-600 relative">
            KI
            {/* Subtle underline accent */}
            <span className="absolute -bottom-0.5 left-0 right-0 h-0.5 bg-teal-600/30 rounded-full" />
          </span>
          <span className="text-slate-900">pilot</span>
        </span>
      )}
    </div>
  );
};

/**
 * Kompakte Version für Sidebar (collapsed)
 */
export const LogoIcon = ({ className }) => (
  <div className={cn('w-8 h-8 relative rounded-xl bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center shadow-lg', className)}>
    <svg viewBox="0 0 32 32" className="w-[60%] h-[60%]" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M16 4L22 12L28 10L24 16L28 22L22 20L16 28L10 20L4 22L8 16L4 10L10 12L16 4Z" 
        fill="#2BAE9B" 
      />
      <circle cx="16" cy="16" r="4" fill="white" fillOpacity="0.9" />
    </svg>
  </div>
);

/**
 * Logo für dunklen Hintergrund (z.B. Login-Seite links)
 */
export const LogoDark = ({ size = 'large', className }) => {
  const sizes = {
    default: { icon: 'w-10 h-10', text: 'text-xl' },
    large: { icon: 'w-12 h-12', text: 'text-2xl' },
    hero: { icon: 'w-14 h-14', text: 'text-3xl' }
  };

  const s = sizes[size] || sizes.large;

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <div className={cn(s.icon, 'relative rounded-xl bg-teal-600 flex items-center justify-center shadow-lg')}>
        <svg viewBox="0 0 32 32" className="w-[60%] h-[60%]" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M16 4L22 12L28 10L24 16L28 22L22 20L16 28L10 20L4 22L8 16L4 10L10 12L16 4Z" 
            fill="white" 
          />
          <circle cx="16" cy="16" r="4" fill="#2BAE9B" />
        </svg>
      </div>
      <span className={cn('font-display font-bold tracking-tight', s.text)}>
        <span className="text-white">mar</span>
        <span className="text-teal-400">KI</span>
        <span className="text-white">pilot</span>
      </span>
    </div>
  );
};

export default Logo;
